/* ==========================================================================
   LAUZON — Brand index (/pages/brands)

   Everything here is progressive enhancement. The full A–Z, every brand link
   and the letter nav are server-rendered by lauzon-brand-index.liquid; this
   file only measures the sticky header, tracks which letter you are in, and
   reveals groups on scroll. It never adds, removes or hides a brand link.
   With JS off the page is complete and crawlable — which is the point, since
   the brand URLs carry 11,174 organic clicks between them.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-brandx]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Sticky offset ------------------------------------------------
     The theme header is position:sticky at top:0 on its section wrapper, so
     the letter rail has to sit below whatever it currently measures. */
  function measureHeader() {
    var header = document.querySelector('.lauzon-header-section, .site-header');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    root.style.setProperty('--brandx-header-h', h + 'px');
  }
  measureHeader();
  window.addEventListener('resize', debounce(measureHeader, 150));
  window.addEventListener('load', measureHeader);

  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-brandx-group]'));
  var jumpLinks = Array.prototype.slice.call(root.querySelectorAll('a.brandx-jump-link'));

  /* ---------- Jump links -------------------------------------------------
     Native anchors do the scrolling. This only moves focus to the letter so
     the next Tab continues from where the eye landed, not from the rail. */
  jumpLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (target) window.setTimeout(function () { target.focus({ preventScroll: true }); }, 0);
    });
  });

  /* ---------- Which letter am I in ---------- */
  var marks = groups
    .map(function (g) { return g.querySelector('.brandx-letter-mark[id]'); })
    .filter(Boolean);

  var lastCurrent;

  function syncCurrent() {
    var railH = root.querySelector('.brandx-jump');
    var line = (railH ? railH.getBoundingClientRect().bottom : 0) + 8;
    var current = null;

    marks.forEach(function (mark) {
      if (mark.getBoundingClientRect().top <= line) current = mark.id;
    });

    if (current === lastCurrent) return;
    lastCurrent = current;

    /* All measuring first, then all mutating — interleaving classList writes
       with getBoundingClientRect reads across 26 links forces a reflow per
       iteration, on every scroll frame. */
    var active = null;
    var list = jumpLinks.length ? jumpLinks[0].parentElement.parentElement : null;
    var needsScroll = false;
    var scrollLeft = 0;

    if (current && list) {
      for (var i = 0; i < jumpLinks.length; i++) {
        if (jumpLinks[i].getAttribute('href') === '#' + current) { active = jumpLinks[i]; break; }
      }
      if (active && list.scrollWidth > list.clientWidth) {
        var lb = active.getBoundingClientRect();
        var cb = list.getBoundingClientRect();
        if (lb.left < cb.left || lb.right > cb.right) {
          needsScroll = true;
          scrollLeft = active.offsetLeft - list.clientWidth / 2 + active.offsetWidth / 2;
        }
      }
    }

    jumpLinks.forEach(function (link) { link.classList.toggle('is-current', link === active); });

    if (needsScroll) {
      list.scrollTo({ left: scrollLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { syncCurrent(); ticking = false; });
  }, { passive: true });
  syncCurrent();

  /* ---------- Reveal -----------------------------------------------------
     Per group, not per card: 136 cards would mean 136 ScrollTriggers for no
     visible gain. Nothing is hidden until we know GSAP is here and motion is
     wanted, so a failed script never costs a reader the list. */
  var wantsMotion = root.getAttribute('data-animate') !== 'false';

  if (wantsMotion && !reduced.matches && window.gsap && window.ScrollTrigger) {
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    /* No CSS arming class. On a page whose entire value is being readable,
       "GSAP set opacity 0 and then something threw" must not be reachable —
       fromTo owns both ends of the tween and nothing hides content but it. */
    gsap.utils.toArray(groups).forEach(function (group) {
      gsap.fromTo(
        group,
        { opacity: 0, y: 18 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out',
          clearProps: 'transform',
          scrollTrigger: { trigger: group, start: 'top 92%', once: true }
        }
      );
    });

    reduced.addEventListener('change', function (e) {
      if (!e.matches) return;
      window.ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
      groups.forEach(function (g) { gsap.set(g, { clearProps: 'all' }); });
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      window.clearTimeout(t);
      t = window.setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }
})();
